import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PeraturanData = {
  CLW_ISI_IDX: number;
  CLW_ISI_NOMOR: string;
  CLW_ISI_TAHUN: string;
  CLW_MENU_NAME: string;
  CLW_VIEW: number;
  CLW_ISI_KETERANGAN: string;
  CLW_BERLAKU: number;
  TYPE_SUBJECT: number;
  UNIT_SUBJECT: number;
  TANGGAL_SUBJECT: number;
  CREATED_SUBJECT: number;
};

type InitialState = {
  dataPeraturan: PeraturanData[];
  totalData: number;
};

const initialState: InitialState = {
  dataPeraturan: [
    
    // Add more data items as needed
  ],
  totalData: 0, // Initialize totalData here
};

export const dokumen = createSlice({
  name: 'dokumen',
  initialState,
  reducers: {
    replaceAllPeraturan: (state, action: PayloadAction<PeraturanData[]>) => {
      state.dataPeraturan = action.payload; // Replace the entire array with the new array
    },
    updateTotalData: (state, action: PayloadAction<number>) => {
      state.totalData = action.payload; // Update the totalData value in the state
    },
  },
});

export const { replaceAllPeraturan, updateTotalData } = dokumen.actions;
export default dokumen.reducer;
